import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomDialog from 'components/CustomDialog';
import SetFirstPasswordForm from 'components/SetFirstPasswordForm';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { resetPassword } from 'store/slices/user';
import { Typography } from '@mui/material';

interface Params {
    hash: string;
}

const ResetPassword: React.FC = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { hash } = useParams<Params>();
    const user = useAppSelector((state) => state.user);
    const { resettingPassword, resetPasswordSuccess, resetPasswordError, resetPasswordErrorMsg } = user;

    const handleSubmit = (password: string) => {
        void dispatch(resetPassword({ hash, password }));
    };

    if (resetPasswordSuccess) {
        setTimeout(() => history.push('/sign-in'), 2000);
    }

    return (
        <CustomDialog
            processing={resettingPassword}
            processingCopy="Resetting password..."
            error={resetPasswordError}
            errorContent={
                <Typography>{resetPasswordErrorMsg || 'This reset link is invalid or has expired.'}</Typography>
            }
            success={resetPasswordSuccess}
            successContent={
                <>
                    <Typography variant="subtitle1">Password updated!</Typography>
                    <Typography variant="body1">Redirecting you to sign in...</Typography>
                </>
            }
            title="Reset password"
            onClose={() => history.push('/sign-in')}
        >
            {!resettingPassword && !resetPasswordSuccess && !resetPasswordError ? (
                <SetFirstPasswordForm
                    onSubmit={handleSubmit}
                    isProcessing={resettingPassword}
                    submitLabel="Set new password"
                />
            ) : null}
        </CustomDialog>
    );
};

export default ResetPassword;
